import React from 'react';
import styles from 'Styles/components/button.module.css';
import classNames from 'classnames';
import 'Styles/index.css';
import { Link } from 'react-router-dom';
import SVGArrow from './SVGArrow';
import useDelayedNavigate from 'Hooks/useDelayedNavigate';

const Button = ({
  className,
  disabled = false,
  marginTop = false,
  type = "link", // possible values: "link" or "action"
  clickCB = () => {}, // callback function used if type == "action"
  to ="/",  // link target used if type == "link"
  children,
  submit = false, // adds type submit to button element, only applicable to type = action
  delay, // ms to delay before navigating to link (for animation/transition)
  ...props
}) => {
	
  
  const buttonClassNames = classNames(
    styles.globalButton,
    className,
    {
      [styles["--margin-top"]]: marginTop,
    }
  );

  const linkClassNames = classNames(
    styles.globalButton,
    styles["globalButton-link"],
    {
      [styles.disabledLink] : disabled, 
    },
    className,
  )

  const {delayedNavigate} = useDelayedNavigate();

  if(type === "link") {
    
    return (
      <Link 
        disabled={disabled} 
        className={linkClassNames} 
        to={to}
        onClick={(e)=>{
          e.preventDefault();
          if(disabled) return;
          delayedNavigate(to, delay);
        }}
        {...props}
      >
        {children}
      </Link>
    )
  }

  return (
    <button 
      disabled={disabled} 
      type={submit ? "submit" : null}
      className={buttonClassNames} 
      onClick={clickCB} {...props}
    >
      {children}
    </button>
  )
};

const NextPageBtn = ({to = "/", ...other}) => {
  return (
    <Button className={styles.navBtn} to={to} {...other} delay={250}>
      <SVGArrow direction="down" className={styles.arrowSVG}/>
    </Button>
  )
}

const PrevPageBtn = ({to = "/", ...other}) => {
  return (
    <Button className={styles.navBtn} to={to} {...other} delay={250}>
      <SVGArrow direction="up" className={styles.arrowSVG}/>
    </Button>
  )
}

const SubmitButton = ({
	isSubmitting = false,
	isSubmitSuccessful = false,
	text = "Submit",
  className,
}) => {
	const spinner = <svg className={styles.buttonSpinner} width="25" height="25" viewBox="0 -0.5 25 25" xmlns="http://www.w3.org/2000/svg"><path d="M4.818 6.664h-.001a1.847 1.847 0 1 1 1.306-.541 1.773 1.773 0 0 1-1.277.541h-.029zm-2.97 7.182h-.001a1.847 1.847 0 1 1 1.306-.541 1.773 1.773 0 0 1-1.278.541h-.031.002zM12 3.692h-.001a1.847 1.847 0 1 1 1.306-.541 1.773 1.773 0 0 1-1.277.541h-.029zM4.818 21.029h-.001a1.847 1.847 0 1 1 1.306-.541 1.769 1.769 0 0 1-1.276.541h-.031zM19.182 7.125a2.308 2.308 0 1 1 0-4.615 2.308 2.308 0 0 1 0 4.615zM12 24h-.001a1.847 1.847 0 1 1 1.306-.541 1.773 1.773 0 0 1-1.277.541h-.029zm10.154-9.231h-.048c-.75 0-1.428-.309-1.913-.807l-.001-.001c-.499-.503-.808-1.196-.808-1.961s.308-1.458.808-1.962a2.663 2.663 0 0 1 1.914-.808h.05-.003.048c.75 0 1.427.309 1.913.807l.001.001c.499.503.808 1.196.808 1.961s-.308 1.458-.808 1.962a2.664 2.664 0 0 1-1.915.809h-.049.002zm-2.971 7.643h-.05a3.097 3.097 0 0 1-2.236-.951l-.001-.001c-.584-.584-.945-1.391-.945-2.283s.361-1.698.945-2.283a3.106 3.106 0 0 1 2.234-.945h.054-.003.042c.877 0 1.67.362 2.237.944l.001.001c.588.582.952 1.39.952 2.283s-.364 1.7-.952 2.282a3.102 3.102 0 0 1-2.24.953h-.04z"/></svg>
  
  const submitBtnClassName = classNames(
    styles.submitButton,
    className,
  );

	return (
		<Button 
      className={submitBtnClassName}
			type="action" submit marginTop
			disabled={isSubmitSuccessful}>
			{isSubmitting ? spinner : text}
		</Button>
	)
}

export {
  Button,
  NextPageBtn, 
  PrevPageBtn,
	SubmitButton,
};